import React from 'react';
import { Link } from 'react-router-dom';
import { INROUTES } from '../../common/links';

import IcSkytone from './../../assets/icon/skytone-frame.svg';

const Home = () => {

    return (
        <>
            <section id="container" className="wrap">
                <div className="app-main">          
                    <div className="visual">
                        <div className="skytone">
                            <img src={IcSkytone} alt="SKYTONE" className="svg"/>
                        </div>
                    </div>
                    <div className="paragraph">
                        <h1 className="title"><strong className="acc">SKYTONE</strong></h1>
                        <p className="desc">하늘의 오염도에 따라 색상이 변화하여 환경 오염을 간편하게 이해하고 외출 전에 대비하는 데 도움을 줍니다.</p>       
                    </div>   
                </div>
                <ul className="menu">
                    <li><Link to={INROUTES.SKYTONE_ABOUT}><span className="no">00</span><span className="name">소개</span></Link></li>
                    <li><Link to={INROUTES.SKYTONE_MODULE}><span className="no">01</span><span className="name">모듈 조립</span></Link></li>
                    <li><Link to={INROUTES.SKYTONE_FRAME}><span className="no">02</span><span className="name">프레임 조립</span></Link></li>
                    <li><Link to={INROUTES.SKYTONE_WIFI}><span className="no">03</span><span className="name">Wi-Fi 설정</span></Link></li>
                    <li><Link to={INROUTES.SKYTONE_SETTING}><span className="no">04</span><span className="name">기능 설정</span></Link></li>
                    <li><Link to={INROUTES.SKYTONE_FAQ}><span className="no">05</span><span className="name">FAQ</span></Link></li>
                    <li><Link to={INROUTES.FINDMYDEVICE} target="_blank" rel="noreferrer" ><span className="no">#</span><span className="name">디바이스 주소 찾기</span></Link></li>
                </ul>
            </section>
            
        </>
    );
};

export default Home;